import React from "react";

const Feed = () => {
  return (
    <div>
      <div className="flex flex-row justify-between">
        <div className="max-w-md">
          <div>
            <svg
              width="50px"
              height="40px"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                id="Vector"
                d="M23.643 2.70502C22.808 3.07502 21.911 3.32502 20.968 3.43802C21.93 2.86202 22.668 1.94802 23.016 0.860023C22.116 1.39402 21.119 1.78202 20.058 1.99002C19.208 1.08602 17.998 0.52002 16.658 0.52002C14.086 0.52002 12 2.60602 12 5.18002C12 5.54402 12.042 5.89802 12.12 6.24002C8.24701 6.04502 4.81601 4.19002 2.51801 1.37202C2.11801 2.06202 1.88801 2.86202 1.88801 3.71402C1.88801 5.33002 2.71101 6.75702 3.96001 7.59202C3.19601 7.56702 2.47801 7.35802 1.85001 7.00902V7.06902C1.85001 9.32602 3.45501 11.209 5.58701 11.637C5.19501 11.743 4.78401 11.799 4.36001 11.799C4.06001 11.799 3.76701 11.771 3.48301 11.717C4.07601 13.567 5.79601 14.915 7.83501 14.951C6.24001 16.201 4.23101 16.946 2.04901 16.946C1.67301 16.946 1.30201 16.924 0.937012 16.881C2.99901 18.204 5.44701 18.974 8.07701 18.974C16.647 18.974 21.332 11.876 21.332 5.72002C21.332 5.52002 21.327 5.31802 21.318 5.11802C22.228 4.46002 23.018 3.64102 23.641 2.70802L23.643 2.70502Z"
                fill="#1D9BF0"
              />
            </svg>
          </div>
          <nav>
            <ul className="flex flex-col my-11 gap-8">
              <li className="flex flex-row items-center gap-1">
                <svg
                  width="28"
                  height="29"
                  viewBox="0 0 28 29"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g mask="url(#mask0_8_700)">
                    <path
                      d="M26.0286 9.57058L14.2417 3.20641C13.9816 3.06641 13.6701 3.06641 13.4099 3.20641L1.62539 9.57058C1.20073 9.80041 1.04206 10.3312 1.2719 10.7571C1.4294 11.0487 1.73156 11.2156 2.0419 11.2156C2.1819 11.2156 2.32539 11.1806 2.45723 11.1106L3.40806 10.5972L5.30856 24.0291C5.55823 25.4466 6.83456 26.4347 8.40956 26.4347H19.2386C20.8159 26.4347 22.0911 25.4454 22.3454 23.9999L24.2424 10.5949L25.1967 11.1106C25.6214 11.3357 26.1534 11.1806 26.3832 10.7559C26.6119 10.3324 26.4532 9.80158 26.0286 9.57058ZM20.6176 23.7257C20.4927 24.4327 19.7974 24.6847 19.2409 24.6847H8.41189C7.85189 24.6847 7.15773 24.4327 7.03756 23.7537L5.05189 9.71057L13.8252 4.97158L22.6009 9.70824L20.6176 23.7257Z"
                      fill="black"
                    />
                    <path
                      d="M9.4152 14.9535C9.4152 17.3849 11.3927 19.3635 13.8252 19.3635C16.2577 19.3635 18.2352 17.3849 18.2352 14.9535C18.2352 12.5222 16.2577 10.5435 13.8252 10.5435C11.3927 10.5435 9.4152 12.5222 9.4152 14.9535ZM16.4852 14.9535C16.4852 16.4212 15.2929 17.6135 13.8252 17.6135C12.3575 17.6135 11.1652 16.4212 11.1652 14.9535C11.1652 13.4859 12.3575 12.2935 13.8252 12.2935C15.2929 12.2935 16.4852 13.4859 16.4852 14.9535Z"
                      fill="black"
                    />
                  </g>
                </svg>
                Home
              </li>
              <li className="flex flex-row items-center gap-1">
                <svg
                  width="28"
                  height="29"
                  viewBox="0 0 28 29"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g mask="url(#mask0_8_707)">
                    <path
                      d="M24.2085 10.2018H19.6235L20.0575 5.21781C20.0995 4.73714 19.7425 4.31364 19.2618 4.27048C18.7753 4.23548 18.3565 4.58548 18.3145 5.06731L17.8677 10.2006H10.4943L10.926 5.21896C10.9692 4.73713 10.611 4.31364 10.1327 4.27048C9.64266 4.23548 9.22616 4.58548 9.18416 5.06731L8.73849 10.2006H4.12083C3.63783 10.2006 3.24583 10.5938 3.24583 11.0756C3.24583 11.5575 3.63783 11.9506 4.12083 11.9506H8.58683L7.94516 19.3321H3.2085C2.7255 19.3321 2.3335 19.7241 2.3335 20.2071C2.3335 20.6901 2.7255 21.0821 3.2085 21.0821H7.7935L7.35949 26.0661C7.31749 26.5468 7.67449 26.9703 8.15516 27.0135L8.23216 27.017C8.68133 27.017 9.06283 26.6728 9.1025 26.2166L9.54933 21.0833H16.9227L16.491 26.065C16.449 26.5468 16.806 26.9703 17.2867 27.0135L17.3637 27.017C17.8128 27.017 18.1943 26.6728 18.234 26.2166L18.6797 21.0833H23.2962C23.778 21.0833 24.1712 20.6901 24.1712 20.2083C24.1712 19.7265 23.778 19.3333 23.2962 19.3333H18.8302L19.4718 11.9518H24.2085C24.6915 11.9518 25.0835 11.5598 25.0835 11.0768C25.0835 10.5938 24.6915 10.2018 24.2085 10.2018ZM17.0743 19.3321H9.701L10.3427 11.9518H17.716L17.0743 19.3321Z"
                      fill="black"
                    />
                  </g>
                </svg>
                Explore
              </li>
              <li className="flex flex-row items-center gap-1">
                <svg
                  width="28"
                  height="29"
                  viewBox="0 0 28 29"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g mask="url(#mask0_8_711)">
                    <path
                      d="M25.3142 20.0624C25.2909 20.0438 22.8175 18.1491 22.8607 13.0274C22.884 10.0734 21.9134 7.44841 20.1225 5.63658C18.5184 4.01141 16.3461 3.11308 14.0069 3.10141H13.9917C11.6537 3.11308 9.48139 4.01142 7.87606 5.63776C6.08639 7.44959 5.1134 10.0734 5.13906 13.0274C5.18223 18.0791 2.78239 19.9889 2.68673 20.0624C2.38339 20.2876 2.25973 20.6808 2.37756 21.0401C2.49656 21.3994 2.83255 21.6409 3.20821 21.6409H8.94823C9.06723 24.3359 11.278 26.4943 13.9999 26.4943C16.7217 26.4943 18.9302 24.3359 19.0481 21.6409H24.7904C25.1661 21.6409 25.502 21.4006 25.6187 21.0413C25.7389 20.6831 25.6152 20.2887 25.3119 20.0636L25.3142 20.0624ZM14.0011 24.7407C12.2452 24.7407 10.8161 23.3676 10.7017 21.6398H17.3004C17.1837 23.3664 15.7569 24.7431 14.0011 24.7431V24.7407ZM5.11106 19.8898C5.9744 18.5691 6.91706 16.3571 6.88906 13.0111C6.86806 10.4911 7.64039 8.36542 9.12089 6.86625C10.3961 5.57475 12.1309 4.85958 14.0011 4.85141C15.8712 4.86074 17.6025 5.57476 18.8777 6.86742C20.3594 8.36659 21.1329 10.4911 21.1119 13.0123C21.0839 16.3583 22.0277 18.5714 22.891 19.8909H5.11106V19.8898Z"
                      fill="black"
                    />
                  </g>
                </svg>
                Notifications
              </li>
              <li className="flex flex-row items-center gap-1">
                <svg
                  width="28"
                  height="29"
                  viewBox="0 0 24 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g mask="url(#mask0_8_714)">
                    <path
                      d="M19.25 3.76807H4.75C3.233 3.76807 2 5.00207 2 6.52007V19.0151C2 20.5331 3.233 21.7681 4.75 21.7681H19.25C20.767 21.7681 22 20.5331 22 19.0151V6.52007C22 5.00207 20.767 3.76807 19.25 3.76807ZM4.75 5.26807H19.25C19.94 5.26807 20.5 5.82807 20.5 6.51807V7.23206L12.45 12.5991C12.177 12.7791 11.824 12.7811 11.55 12.5971L3.5 7.23206V6.51807C3.5 5.82807 4.06 5.26807 4.75 5.26807ZM19.25 20.2661H4.75C4.06 20.2661 3.5 19.7061 3.5 19.0161V8.99007L10.74 13.8201C11.123 14.0761 11.562 14.2041 12 14.2041C12.44 14.2041 12.877 14.0761 13.26 13.8211L20.5 8.99106V19.0131C20.5 19.7031 19.94 20.2631 19.25 20.2631V20.2661Z"
                      fill="black"
                    />
                  </g>
                </svg>
                Messages
              </li>
              <li className="flex flex-row items-center gap-1">
                <svg
                  width="28"
                  height="29"
                  viewBox="0 0 24 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g mask="url(#mask0_8_717)">
                    <path
                      d="M19.55 22.9181C19.393 22.9181 19.238 22.8681 19.108 22.7741L11.65 17.3461L4.192 22.7761C3.964 22.9401 3.66199 22.9661 3.40999 22.8361C3.15999 22.7091 3 22.4511 3 22.1691V5.01807C3 3.77807 4.01 2.76807 5.25 2.76807H18.048C19.288 2.76807 20.298 3.77807 20.298 5.01807V22.1681C20.298 22.4501 20.14 22.7081 19.888 22.8361C19.782 22.8911 19.665 22.9181 19.548 22.9181H19.55ZM11.65 15.6681C11.805 15.6681 11.96 15.7161 12.09 15.8121L18.8 20.6951V5.01807C18.8 4.60607 18.463 4.26807 18.05 4.26807H5.25C4.837 4.26807 4.5 4.60607 4.5 5.01807V20.6951L11.21 15.8121C11.34 15.7161 11.495 15.6681 11.65 15.6681Z"
                      fill="black"
                    />
                  </g>
                </svg>
                Bookmarks
              </li>
              <li className="flex flex-row items-center gap-1">
                <svg
                  width="28"
                  height="29"
                  viewBox="0 0 24 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g mask="url(#mask0_8_720)">
                    <path
                      d="M19.75 22.7681H4.25C3.01 22.7681 2 21.7581 2 20.5181V5.01807C2 3.77807 3.01 2.76807 4.25 2.76807H19.75C20.99 2.76807 22 3.77807 22 5.01807V20.5181C22 21.7581 20.99 22.7681 19.75 22.7681ZM4.25 4.26807C3.836 4.26807 3.5 4.60507 3.5 5.01807V20.5181C3.5 20.9311 3.836 21.2681 4.25 21.2681H19.75C20.164 21.2681 20.5 20.9311 20.5 20.5181V5.01807C20.5 4.60507 20.164 4.26807 19.75 4.26807H4.25Z"
                      fill="black"
                    />
                    <path
                      d="M16.75 9.26807H6.75C6.336 9.26807 6 8.93107 6 8.51807C6 8.10507 6.336 7.76807 6.75 7.76807H16.75C17.164 7.76807 17.5 8.10307 17.5 8.51807C17.5 8.93307 17.164 9.26807 16.75 9.26807ZM16.75 13.3781H6.75C6.336 13.3781 6 13.0421 6 12.6281C6 12.2141 6.336 11.8781 6.75 11.8781H16.75C17.164 11.8781 17.5 12.2141 17.5 12.6281C17.5 13.0421 17.164 13.3781 16.75 13.3781ZM11.75 17.4881H6.75C6.336 17.4881 6 17.1531 6 16.7381C6 16.3231 6.336 15.9881 6.75 15.9881H11.75C12.164 15.9881 12.5 16.3251 12.5 16.7381C12.5 17.1511 12.164 17.4881 11.75 17.4881Z"
                      fill="black"
                    />
                  </g>
                </svg>
                Lists
              </li>
              <li className="flex flex-row items-center gap-1">
                <svg
                  width="28"
                  height="29"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g mask="url(#mask0_15_733)">
                    <path
                      d="M11.351 12.16C12.706 12.16 14.223 12.01 15.191 10.904C16.005 9.974 16.269 8.536 15.997 6.512C15.617 3.687 13.88 2 11.351 2C8.82198 2 7.08498 3.687 6.70498 6.514C6.43298 8.536 6.69698 9.974 7.51098 10.904C8.47898 12.011 9.99598 12.16 11.351 12.16ZM8.19098 6.712C8.35298 5.512 8.97798 3.5 11.351 3.5C13.724 3.5 14.349 5.513 14.511 6.712C14.718 8.262 14.568 9.339 14.061 9.917C13.606 10.437 12.795 10.66 11.351 10.66C9.90698 10.66 9.09598 10.437 8.64098 9.917C8.13398 9.339 7.98398 8.261 8.19098 6.712ZM19.631 19.58C18.754 16.054 15.349 13.59 11.351 13.59C7.35298 13.59 3.94798 16.054 3.07098 19.58C2.89898 20.272 3.04298 20.98 3.46598 21.52C3.87398 22.04 4.50598 22.34 5.19898 22.34H17.503C18.196 22.34 18.828 22.04 19.236 21.52C19.66 20.98 19.803 20.273 19.63 19.58H19.631ZM18.055 20.596C17.929 20.756 17.739 20.842 17.503 20.842H5.19898C4.96398 20.842 4.77298 20.757 4.64698 20.596C4.50998 20.422 4.46698 20.184 4.52698 19.942C5.23698 17.087 8.04398 15.092 11.351 15.092C14.658 15.092 17.465 17.086 18.175 19.942C18.235 20.184 18.192 20.422 18.055 20.596Z"
                      fill="black"
                    />
                  </g>
                </svg>
                Profile
              </li>
              <li className="flex flex-row items-center gap-1">
                <svg
                  width="28"
                  height="29"
                  viewBox="0 0 28 29"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g mask="url(#mask0_8_820)">
                    <path
                      d="M18.9582 12.4347C17.8323 12.4347 16.9165 13.3529 16.9165 14.4764C16.9165 15.5999 17.8312 16.5181 18.9582 16.5181C20.0828 16.5181 20.9998 15.6011 20.9998 14.4764C20.9998 13.3517 20.0828 12.4347 18.9582 12.4347ZM18.9582 15.3514C18.4752 15.3514 18.0832 14.9594 18.0832 14.4764C18.0832 13.9946 18.4763 13.6014 18.9582 13.6014C19.44 13.6014 19.8332 13.9934 19.8332 14.4764C19.8332 14.9582 19.4412 15.3514 18.9582 15.3514ZM13.7082 12.4347C12.5812 12.4347 11.6665 13.3529 11.6665 14.4764C11.6665 15.5999 12.5823 16.5181 13.7082 16.5181C14.834 16.5181 15.7498 15.6011 15.7498 14.4764C15.7498 13.3517 14.8352 12.4347 13.7082 12.4347ZM13.7082 15.3514C13.2252 15.3514 12.8332 14.9594 12.8332 14.4764C12.8332 13.9946 13.2263 13.6014 13.7082 13.6014C14.19 13.6014 14.5832 13.9934 14.5832 14.4764C14.5832 14.9582 14.1912 15.3514 13.7082 15.3514ZM8.45817 12.4347C7.33234 12.4347 6.4165 13.3529 6.4165 14.4764C6.4165 15.5999 7.33234 16.5181 8.45817 16.5181C9.58284 16.5181 10.4998 15.6011 10.4998 14.4764C10.4998 13.3517 9.58167 12.4347 8.45817 12.4347ZM8.45817 15.3514C7.97517 15.3514 7.58317 14.9594 7.58317 14.4764C7.58317 13.9946 7.97634 13.6014 8.45817 13.6014C8.94 13.6014 9.33317 13.9934 9.33317 14.4764C9.33317 14.9582 8.94117 15.3514 8.45817 15.3514Z"
                      fill="black"
                    />
                    <path
                      d="M13.7082 27.0181C6.79217 27.0181 1.1665 21.3924 1.1665 14.4764C1.1665 7.56039 6.79217 1.93472 13.7082 1.93472C20.6242 1.93472 26.2498 7.56039 26.2498 14.4764C26.2498 21.3924 20.6242 27.0181 13.7082 27.0181ZM13.7082 3.68472C7.75817 3.68472 2.9165 8.52639 2.9165 14.4764C2.9165 20.4264 7.75817 25.2681 13.7082 25.2681C19.6582 25.2681 24.4998 20.4264 24.4998 14.4764C24.4998 8.52639 19.6582 3.68472 13.7082 3.68472Z"
                      fill="black"
                    />
                  </g>
                </svg>
                More
              </li>
            </ul>
            <div className="flex flex-col justify-center my-4 w-[100%] bg-[#1D9BF0] text-center min-w-[52px] min-h-[52px] rounded-[76px]">
              <a href="/" className="text-white font-bold">
                Tweet
              </a>
            </div>
          </nav>
          <div>Logged Profile Info</div>
        </div>
        <div>
          <h3>Home</h3>
          <div>Write Tweet</div>
          <div>Feeds</div>
        </div>
        <div>
          <div>Search</div>
          <div>Trends</div>
          <div>You might like</div>
          <footer>Blablalba</footer>
        </div>
      </div>
    </div>
  );
};

export default Feed;
